import { useContext } from 'react';
import PropTypes from 'prop-types';
import { UserContext } from 'context';

/**
 * Allow actions according to organization type
 * @param {node} children The element to be rendered
 * @param {array} subject Contains all organizations type
 */
const OrgAbility = ({ children, subject, allowed }) => {
  const { orgType } = useContext(UserContext);

  const isAllowed = () => {
    if (subject?.includes(orgType) || allowed) {
      return true;
    }
  };

  return isAllowed() ? children : null;
};

OrgAbility.propTypes = {
  allowed: PropTypes.bool,
  subject: PropTypes.array.isRequired,
  children: PropTypes.node.isRequired,
};

OrgAbility.defaultProps = {
  allowed: false,
  subject: [],
};

export default OrgAbility;
